// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"123":"d4bedd1e","371":"a423b51b","398":"3a82a33c","755":"7fc91c8d","941":"d9b54a61"}[chunkId] + ".chunk.js";
};